interface BlogPost {
  title: string;
  slug: string;
  featured: boolean;
  publishedAt: string;
  author: string;
  excerpt: string;
  banner: string;
  tags: string[];
  canonicalUrl?: string;
  content?: string;
}

export default BlogPost;

export const sortBlogPosts = (posts: BlogPost[]) => {
  const sortedPosts = posts.sort((a: BlogPost, b: BlogPost) => {
    if (a.publishedAt > b.publishedAt) return 1;
    if (a.publishedAt < b.publishedAt) return -1;
    return 0;
  });
  return sortedPosts.reverse();
};

export const extractFeaturedPost = (posts: BlogPost[]) => {
  const featuredPosts = posts.filter((post) => post.featured);

  if (featuredPosts.length !== 1) {
    throw new Error(
      `Must have exactly one featured post. Currently featured: ${featuredPosts
        .map((post) => post.slug)
        .join(", ")}`
    );
  }

  return {
    featuredPost: featuredPosts[0],
    posts: posts.filter((post) => !post.featured),
  };
};

export const formatBlogPublishDate = (publishDate: string) =>
  new Date(publishDate).toLocaleDateString("en-us", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
